// React
import React from 'react';

// Packages

// Utilities
import { CONSTANTS } from 'utilities/configuration';

// Components
import {
    ResultReflections,
    ResultDetails,
    ResultChoice,
    ResultDataCard,
    ResultSetFieldValues,
} from '../_common';

const Name = CONSTANTS.RESULTS.CUSTOM_OUTPUT;

const Choice = props => {
    return ResultChoice({
        Name: `${Name}___Basic`,
        ...props,
    });
};

const DataCard = ({ item, theme = 'teal', mode = [] }) => {
    return (
        <ResultDataCard
            {...{
                item,
                theme,
                showDetails: mode.includes('details'),
            }}
        />
    );
};

const Details = props => {
    return ResultDetails({
        ...props,
    });
};

const Reflections = props => {
    return ResultReflections({
        ...props,
    });
};

const setFieldValues = ({ choice, form, id, utilities, REPORT_ID }) => {
    ResultSetFieldValues({
        choice,
        form,
        id,
        utilities,
        REPORT_ID,
    });
};

export { Name, DataCard, Choice, Details, Reflections, setFieldValues };
